import { Box, VStack, Icon, Link, Text, Button } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FiBook, FiTag, FiMessageSquare, FiUser, FiLogOut, FiSettings, FiDollarSign, FiHome } from 'react-icons/fi';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const { logout } = useAuth();

  const isActive = (path: string) => {
    return location.pathname === `/app${path}`;
  };

  const menuItems = [
    { path: '/dashboard', icon: FiHome, label: 'Dashboard' },
    { path: '/journal', icon: FiBook, label: 'Journal' },
    { path: '/tags', icon: FiTag, label: 'Tags' },
    // { path: '/habits', icon: FiActivity, label: 'Habits' },
    // { path: '/analytics', icon: FiBarChart2, label: 'Analytics' },
    { path: '/chat', icon: FiMessageSquare, label: 'AI Chat' },
    { path: '/profile', icon: FiUser, label: 'Profile' },
    { path: '/settings', icon: FiSettings, label: 'Settings' },
    { path: '/pricing', icon: FiDollarSign, label: 'Pricing' },
  ];

  return (
    <Box
      as="nav"
      pos="sticky"
      top={0}
      w="240px"
      h="100vh"
      bg="white"
      borderRight="1px"
      borderColor="gray.200"
      py={8}
      px={4}
      _dark={{
        bg: 'gray.800',
        borderColor: 'gray.700',
      }}
    >
      <VStack spacing={2} align="stretch">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            as={RouterLink}
            to={`/app${item.path}`}
            display="flex"
            alignItems="center"
            p={3}
            borderRadius="md"
            color={isActive(item.path) ? 'blue.500' : 'gray.600'}
            bg={isActive(item.path) ? 'blue.50' : 'transparent'}
            _hover={{
              bg: 'blue.50',
              textDecoration: 'none',
            }}
            _dark={{
              color: isActive(item.path) ? 'blue.200' : 'gray.300',
              bg: isActive(item.path) ? 'blue.900' : 'transparent',
              _hover: {
                bg: 'blue.900',
              },
            }}
          >
            <Icon as={item.icon} mr={3} />
            <Text>{item.label}</Text>
          </Link>
        ))}

        <Button
          variant="ghost"
          leftIcon={<Icon as={FiLogOut} />}
          onClick={logout}
          mt={4}
          w="full"
          justifyContent="flex-start"
          color="gray.600"
          _dark={{
            color: 'gray.300',
          }}
        >
          Logout
        </Button>
      </VStack>
    </Box>
  );
};

export default Sidebar; 